import React from 'react'
import { Modal, Button, Typography } from 'antd'
import { FacebookOutlined, XOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import './under-development-modal.css'

const { Title, Paragraph, Text } = Typography

interface UnderDevelopmentModalProps {
  visible: boolean
  onClose: () => void
  featureName: string
}

const UnderDevelopmentModal: React.FC<UnderDevelopmentModalProps> = ({
  visible,
  onClose,
  featureName
}) => {
  const { i18n } = useTranslation(['common', 'navigation'])

  const handleFollowFacebook = () => {
    window.open('https://www.facebook.com/wellchineseapp', '_blank')
  }

  const handleFollowTwitter = () => {
    window.open('https://x.com/wellchineseapp', '_blank')
  }

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          {i18n.language === 'zh' ? '关闭' : 'Close'}
        </Button>,
        <Button key="facebook" type="primary" icon={<FacebookOutlined />} onClick={handleFollowFacebook}>
          {i18n.language === 'zh' ? '关注 Facebook' : 'Follow Facebook'}
        </Button>
      ]}
      width={480}
      centered
    >
      <div className="under-development-modal__content">
        <div className="under-development-modal__icon-shell">
          <FacebookOutlined className="under-development-modal__icon" />
        </div>

        <Title level={3} className="under-development-modal__title">
          {i18n.language === 'zh' ? '功能开发中' : 'Under Development'}
        </Title>

        <Paragraph className="under-development-modal__description">
          {i18n.language === 'zh'
            ? `「${featureName}」功能正在开发中，敬请期待！`
            : `The "${featureName}" feature is currently under development. Stay tuned!`}
        </Paragraph>

        <div className="under-development-modal__social-card">
          <Text className="under-development-modal__social-text">
            {i18n.language === 'zh'
              ? '关注我们的社交媒体，获取最新开发进展：'
              : 'Follow us on social media for the latest development updates:'}
          </Text>
          <div className="under-development-modal__social-links">
            <Button
              type="link"
              icon={<FacebookOutlined />}
              onClick={handleFollowFacebook}
              className="under-development-modal__social-link"
            >
              Facebook
            </Button>
            <Button
              type="link"
              icon={<XOutlined />}
              onClick={handleFollowTwitter}
              className="under-development-modal__social-link"
            >
              Twitter (X)
            </Button>
          </div>
        </div>

        <Paragraph className="under-development-modal__note">
          {i18n.language === 'zh'
            ? '我们会在功能完成后第一时间通知大家。'
            : 'We will notify everyone as soon as the feature is completed.'}
        </Paragraph>
      </div>
    </Modal>
  )
}

export default UnderDevelopmentModal
